/**
 * This page is cloned from the grades page so it might
 * have similar naming conventions to the grades page
 *
 */

import { useEffect, useRef, useState } from "react";
import { NavLink as Link } from "react-router-dom";
import { endpoints } from "../../hooks/endpoints";
import Animation from "../Animation";

import { pushModal } from "@/store/slices/modalsSlice";
import { useDispatch } from "react-redux";
import {
  convertText,
  getAllowedCategoriesForPermission,
  getToken,
  reorderForPagination,
} from "../../hooks/utils";
import { useAppSelector } from "../../store/hooks";
import GeneralMessageModal from "../Modals/GeneralMessageModal";
import Spinner from "../Spinner";
import DynamicCategorySelector from "./DynamicCategorySelector";
// const names = [
//   "أحمد محمود عبد الرحمن",
//   "يوسف علي مصطفى",
//   "سارة خالد الزهراني",
//   "محمد إبراهيم الفاروقي",
//   "نور حسن البكري",
//   "زينب سامي العتيبي",
//   "عمر فؤاد الكيلاني",
//   "لينا طارق الجبالي",
//   "خالد ناصر الشمري",
//   "ريم عبد الله السعدي",
//   "أيمن ياسر الديب",
//   "مروة أحمد الطحاوي",
//   "حسن عبد الكريم القادري",
//   "مها فيصل الدوسري",
//   "زياد كمال الهاشمي",
// ];

// const getNumber = () => {
//   const num = Math.random() * 100000000 + 100000000;
//   return Math.round(num);
// };
// const getGradesData = () => {
//   const grades = [];
//   for (let i = 0; i < 15; i++) {
//     grades.push({
//       ID: i + 1,
//       post_date: "2025-02-12 17:22:24",
//       title:
//         "Chapter (4) Lesson(3) (2025)-71785-Quiz (22) (2025)-جون امير اسحق منصور",
//       quiz_id: "71785",
//       quiz: "Quiz (22) (2025)-71785",
//       student: `${names[i]}-johnishak81@gmail.com-2856`,
//       student_id: "2856",
//       student_phone: `0${getNumber()}`,
//       parent_phone: `0${getNumber()} - 0${getNumber()}`,
//       grade: Math.round(Math.random() * 10),
//       student_name: names[i],
//       date_submitted: "2025-02-12",
//       answers:
//         "71775-A-true,71776-B-true,71777-C-true,71778-D-true,71779-C-true,71780-B-true,71781-A-true,71782-A-true,71783-A-true,71784-D-true",
//       raw_data:
//         '{"71775":{"answer":"A","correct":true},"71776":{"answer":"B","correct":true},"71777":{"answer":"C","correct":true},"71778":{"answer":"D","correct":true},"71779":{"answer":"C","correct":true},"71780":{"answer":"B","correct":true},"71781":{"answer":"A","correct":true},"71782":{"answer":"A","correct":true},"71783":{"answer":"A","correct":true},"71784":{"answer":"D","correct":true},"score":10,"maxScore":10}',
//       lesson_id: "56193",
//     });
//   }
//   return grades;
// };

interface AssessmentReportI {
  ID: string;
  answers: string;
  date_submitted: string;
  grade: string;
  homework: string;
  homework_id: string;
  lesson_id: string;
  parent_phone: string;
  post_date: string;
  raw_data: string;
  student: string;
  student_id: string;
  student_name: string;
  student_phone: string;
  title: string;
}

const QuizResults = () => {
  const [gradesStart, setgradesStart] = useState(0);
  const [allgrades, setAllgrades] = useState<AssessmentReportI[]>();
  const [grades, setgrades] = useState<AssessmentReportI[]>();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [displayedReport, setDisplayedReport] = useState<
    AssessmentReportI[] | null
  >(null);
  // const [cats, setCats] = useState();
  const [currentCat, setCurrentCat] = useState<string>();
  const [groups, setGroups] = useState();
  const [isPending, setIsPending] = useState(false);
  const [error, setError] = useState(null);
  const [selectedLesson, setSelectedLesson] = useState(null);
  // const [teacherData, setTeacherData] = useState({ name: "", subject: "" });
  // const lessonRef = useRef<HTMLSelectElement>();
  const gradeTypeRef = useRef();

  const dispatch = useDispatch();

  const { userProfileData, portal } = useAppSelector((state) => state.store);
  const teacherData = {
    name: userProfileData.teacher_name,
    subject: userProfileData.teacher_subject,
  };

  const allowedCats = getAllowedCategoriesForPermission("can_publish_lessons");
  const cats = allowedCats
    ? portal?.cats?.filter((cat) => allowedCats.includes(cat.term_id))
    : portal?.cats;
  const lessons = portal?.data;

  const formatPhoneNumber = (phoneNumberString) => {
    return phoneNumberString?.replaceAll(" ", "").split("-");
  };
  const getStudentScore = async (grade, phone) => {
    const data = await JSON.parse(grade.raw_data);

    const text = `https://api.whatsapp.com/send?phone=2${phone}&text=السادة%20أولياء%20أمر%20الطالب/ة%20${
      grade.student_name
    }%20,%20نتيجة%20${
      (gradeTypeRef?.current as any)?.value !== "grades" ? "الواجب" : "الاختبار"
    }%20للحصة%20${
      "*" +
      convertText(
        lessons.filter((item) => +item.ID === +selectedLesson)[0].post_title
      ) +
      "*"
    }%20هي%20${data.score + " / " + data.maxScore}%20,%20${
      teacherData.name
    }%20مادة%20${teacherData.subject}`;

    console.log(text);

    window.open(text, "_blank");
  };

  const getFilteredResults = (arr: AssessmentReportI[]) => {
    const newArr = [
      ...arr.filter(
        (grade: AssessmentReportI) => grade.lesson_id === selectedLesson
      ),
      ...arr.filter((grade: AssessmentReportI) => !grade.lesson_id),
    ];
    // const lastArr = [];
    // for (let i = 0; i < newArr.length; i++) {
    //   if (!lastArr.some((item) => item.lesson_id === newArr[i].lesson_id)) {
    //     lastArr.push(newArr[i]);
    //   }
    // }
    return newArr;
  };

  const getGrades = (e) => {
    e.preventDefault();
    setgradesStart(0);
    if (!selectedLesson || (gradeTypeRef?.current as any)?.value === "-") {
      dispatch(
        pushModal(
          <GeneralMessageModal
            msg="يجب اختيار نوع الإمتحان و الحصة"
            btnMsg="حسنا"
          />
        )
      );
      return;
    }
    setIsPending(true);
    fetch(
      endpoints.qzHwResultTeacehr +
        `?lesson=${selectedLesson}&gradetype=${
          (gradeTypeRef?.current as any)?.value
        }`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: getToken(),
        },
        method: "GET",
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setIsPending(false);
        console.log(data);
        setAllgrades(getFilteredResults(data));
        setgrades(getFilteredResults(data));
        setDisplayedReport(
          reorderForPagination({
            arr: getFilteredResults(data),
            currentPage: 1,
            pageCount: 10,
          })
        );
        if (getFilteredResults(data).length === 0) {
          setError("لا يوجد نتائج لهذا الإختبار");
        } else {
          setError(null);
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (grades)
      setDisplayedReport(
        reorderForPagination({
          arr: grades,
          currentPage: currentPage,
          pageCount: 10,
        })
      );
  }, [currentPage]);

  return (
    <Animation>
      <div className="space-y-6">
        <h3 className="bg-primary p-3 text-white rounded-lg shadow font-bold">
          عرض النتائج
        </h3>
        <div className="overflow-x-auto bg-white rounded-lg border shadow-sm p-3">
          <form onSubmit={(e) => getGrades(e)} className="mb-4 space-y-4">
            {/* <select
              onChange={(e) => {
                lessonRef.current.value = null;
                (gradeTypeRef.current as any).value = "-";
                setCurrentCat(e.target.value);
              }}
              className="block w-3/4 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-(--primary-color-light)"
            >
              <option value="-" selected>
                المجموعة
              </option>
              {cats &&
                cats.map((cat) => (
                  <option key={cat.slug} value={cat.slug}>
                    {cat.name.includes("|") ? cat.name.split("|")[0] : cat.name}
                  </option>
                ))}
            </select>

            <select
              ref={lessonRef}
              className="block w-3/4 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-(--primary-color-light)"
            >
              <option value="all" selected>
                الحصة
              </option>
              {lessons &&
                lessons
                  ?.filter(
                    (lesson) =>
                      lesson.term_taxonomy_id ==
                      cats.find((cat) => cat.slug == currentCat)
                        ?.term_taxonomy_id
                  )
                  .map((lesson) => (
                    <option key={lesson.ID} value={lesson.ID}>
                      {convertText(lesson.post_title)}
                    </option>
                  ))}
            </select> */}
            <div className="md:w-3/4 w-full">
              <DynamicCategorySelector
                filteredCats={cats}
                showLessonsSelector={true}
                excludeCatsThatHasLessons={false}
                categoryUpdateHanlderFunction={(value, chosenCatsIds) => {
                  (gradeTypeRef.current as any).value = "-";
                  setCurrentCat(value);
                }}
                lessonUpdateHanlderFunction={setSelectedLesson}
              />
            </div>

            <select
              ref={gradeTypeRef}
              className="block md:w-3/4 w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-(--primary-color-light)"
            >
              <option value="-" selected>
                نوع الإمتحان
              </option>
              <option value="grades">كويز</option>
              <option value="hwgrades">واجب</option>
            </select>

            <input
              type="submit"
              value="عرض"
              disabled={isPending}
              className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-secondary transition"
            />

            {isPending && (
              <div className="grow flex justify-center items-center">
                <Spinner />
              </div>
            )}
          </form>

          {grades && grades.length > 0 && (
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200 border border-gray-200 text-right">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="px-4 py-2 text-sm font-semibold">#</th>
                    <th className="px-4 py-2 text-sm font-semibold">الطالب</th>
                    <th className="px-4 py-2 text-sm font-semibold">
                      رقم الطالب
                    </th>
                    <th className="px-4 py-2 text-sm font-semibold">
                      إرسال التقرير لولي الأمر
                    </th>
                    <th className="px-4 py-2 text-sm font-semibold">الدرجة</th>
                    <th className="px-4 py-2 text-sm font-semibold">التاريخ</th>
                    <th className="px-4 py-2 text-sm font-semibold">تفاصيل</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {grades &&
                    selectedLesson &&
                    displayedReport?.map((grade, index) => (
                      <tr
                        key={grade.ID}
                        className="hover:bg-gray-50 whitespace-nowrap"
                      >
                        <td className="px-4 py-2">
                          {index + 1 + (currentPage - 1) * 10}
                        </td>
                        <td className="px-4 py-2">{grade.student_name}</td>
                        <td className="px-4 py-2">{grade.student_phone}</td>
                        <td className="px-4 py-2">
                          {formatPhoneNumber(grade.parent_phone)?.map(
                            (phone) => (
                              <button
                                key={phone}
                                type="button"
                                onClick={() => getStudentScore(grade, phone)}
                                className="inline-block px-3 py-1 bg-primary text-white rounded-lg hover:bg-secondary transition mx-1"
                              >
                                {phone}
                              </button>
                            )
                          )}
                        </td>
                        <td className="px-4 py-2">{grade.grade}</td>
                        <td className="px-4 py-2">{grade.date_submitted}</td>
                        <td className="px-4 py-2">
                          <Link
                            to={`/grades/${grade.ID}`}
                            className="inline-block px-3 py-1 bg-primary text-white rounded-lg hover:bg-secondary transition"
                          >
                            تفاصيل
                          </Link>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          )}

          <div className="flex gap-2 mt-4">
            {grades && currentPage * 10 < grades.length && (
              <button
                onClick={() => setCurrentPage((prev) => prev + 1)}
                className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-secondary transition"
              >
                التالي
              </button>
            )}
            {grades && currentPage > 1 && (
              <button
                onClick={() => setCurrentPage((prev) => prev - 1)}
                className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-secondary transition"
              >
                السابق
              </button>
            )}
          </div>

          {error && (
            <p className="text-center text-primary my-4 font-semibold text-lg">{error}</p>
          )}
        </div>
      </div>
    </Animation>
  );
};

export default QuizResults;
